import { render, staticRenderFns } from "./AmAvatar.vue?vue&type=template&id=74134e4f&scoped=true&"
import script from "./AmAvatar.vue?vue&type=script&lang=js&"
export * from "./AmAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74134e4f",
  null
  
)

export default component.exports